import { AreaComumDia } from "core/features/area-comum/enums/index";
import { PaginateQuery } from "core/resources/types/shared";

export interface FiltroStatusReserva {
  id: StatusReservaEnum;
  nome: string;
}

export interface DashboardReservaValues {
  hoje: number;
  total: number;
  semAprovacao: number;
}
export interface ReservaForm {
  areaComumId: string;
  responsavelId: string;
  responsavelNome?: string;
  data: string;
  horaInicio: string;
  horaFim?: string;
  nome: string;
  unidadeId: string;
  unidadeNumero?: string;
  observacao?: string;

  // Extra props rumtime
  blocoQuadraId?: string;
  aceitoTermos?: boolean;
}

export interface ReservaFiltro extends PaginateQuery {
  dataInicio: string;
  dataFim: string;
  status?: StatusReservaEnum;
  areaComumId?: string;
  tipoAreaComumId?: string;
}

export enum ReservaFiltroTipoData {
  CriacaoReseva = "criacaoReserva",
  DataReserva = "dataReserva",
}

export enum ReservaTipoPagamento {
  Gratis = "gratis",
  Paga = "paga",
}

export enum ReservaCriacaoOrigem {
  App = "app",
  Backoffice = "backoffice",
}
export interface ReservaFiltroAdv extends PaginateQuery {
  id?: string;
  dataInicio?: string;
  dataFim?: string;
  status?: StatusReservaEnum;
  areaComumId?: string;
  tipoAreaComumIds?: Array<string>;
  unidadeId?: string;
  pessoaId?: string;
  tipoData?: ReservaFiltroTipoData;
  tipoPagamento?: ReservaTipoPagamento;
  origem?: ReservaCriacaoOrigem;
  tenantsIds?: string[];
}

export interface ListagemReservaResponse {
  id: string;
  eventoId: string;
  nomeMorador: string;
  createdAt: string;
  documentoMorador: string;
  fotoMorador?: string;
  unidade: {
    id: string;
    numero: string;
    blocoQuadra?: string;
  };
  nomePessoaConfirmacao?: string | null;
  data: string;
  horaInicio: string;
  horaFim?: string;
  status: { id: StatusReservaEnum; nome: string };
  linkBoleto?: string;
  areaComum: {
    cor: string;
    nome: string;
    id: string;
    tipoAreaComum: {
      nome: string;
      icone: string;
      cor: string;
    };
  };
  valor?: number | null;
  origem?: ReservaCriacaoOrigem;
  tenant?: {
    id: string;
    nome: string;
  };
}

export type CalendarioReservaEvento = ListagemReservaResponse & {
  backgroundColor?: string;
  title: string;
  start: string;
  end?: string;
};

export enum StatusReservaEnum {
  Confirmada = "DBB67288-A6E9-40CD-983E-0F08F594D42A",
  Pendente = "89FFE8A8-021B-4EC9-873D-442CF13DE0CC",
  AguardandoPagamento = "29539778-1AC6-4D40-A21A-5F36DD70C723",
  Cancelada = "C8C70D75-C479-4DC6-B32A-93038292B175",
}

export interface ReservaConvidado {
  nome: string;
  idContato?: string;
  telefone?: string;
}

export interface ReservaResponseDetails {
  id: string;
  nome: string;
  unidadeId: string;
  status: { id: StatusReservaEnum; nome: string };

  data: string;

  horaInicio: string;
  horaFim: string;

  areaComumId: string;
  pessoaId: string;
  observacao: string;
  tipoAreaComum: {
    id: string;
    nome: string;
    cor: string;
    icone: string;
  };
}

export interface ReservaDetalhesResumidoDto {
  id: string;
  createdAt?: string;
  pessoaCriadora?: {
    id: string;
    nome: string;
  };
  pessoa: {
    id: string;
    nome: string;
    imagemUrl: string;
    celular: string;
  };
  dataCancelamento: string | null;
  pessoaCancelamento: {
    id: string;
    nome: string;
  } | null;
  motivoCancelamento: string | null;
  unidade: {
    numero: string;
    blocoQuadra: string;
  };
  statusId: StatusReservaEnum;
  areaComum: {
    id: string;
    nome: string;
    imagemUrl: string;
  };
  nome: string;
  data: string;
  horaInicio: string;
  horaFim: string;
  linkBoleto?: string;
  origem?: ReservaCriacaoOrigem;
  valor?: number | null;
  tenant?: {
    id: string;
    nome: string;
  } | null;
}

export interface AreaComumValor {
  criterioValor: AreaComumDia;
  valor: number | null;
  areaComumId: string;
  id: string;
}
